import { useMutation, UseMutationResult } from '@tanstack/react-query';

import {
  HoldActionErrorDto,
  PlaceHoldDto,
  useFeatureFlag,
  usePatronSession,
} from '@app/hooks';
import { makeRequest, removeEmptyKeys } from '@app/utils';
import { Feature, invokePathPrefix } from '@app/constants';

interface PlaceHoldRequestProps {
  instanceId: string;
  pickupLocationId: string;
  itemId?: string;
  patronComments?: string;
}

export const usePlaceHoldMutation = (): UseMutationResult<
  PlaceHoldDto,
  HoldActionErrorDto,
  PlaceHoldRequestProps
> => {
  const { externalSystemId } = usePatronSession();
  const { isActive: isConsortiaLogin } = useFeatureFlag({
    name: Feature.consortiaLoginFlow,
  });

  return useMutation(
    ({
      instanceId,
      pickupLocationId,
      itemId,
      patronComments,
    }: PlaceHoldRequestProps) => {
      const pathPrefix = isConsortiaLogin ? invokePathPrefix : '';
      const patronPath = `${pathPrefix}/opac-patron/account/${externalSystemId}`;
      const holdPath = itemId
        ? `/item/${itemId}/hold`
        : `/instance/${instanceId}/hold`;

      return makeRequest<PlaceHoldDto>({
        url: `${patronPath}${holdPath}`,
        method: 'POST',
        data: removeEmptyKeys({
          pickupLocationId,
          patronComments,
        }),
        withCredentials: isConsortiaLogin,
      });
    }
  );
};
